import React from 'react';
import './Footer.css';

const Footer = ({
  year=new Date().getFullYear(),
  url='',
  children,
  style = {},
  sticky = false, // <- new prop
  className = '',
}) => {
  const defaultContent = (
    <span>
      © 2025 Copyright:{' '}
      <a
        href={url}
        className="footer-link"
        target="_blank"
        rel="noopener noreferrer"
      >
        {url}
      </a>
    </span>
  );

  return (
    <footer
      className={`aol-footer ${className} ${sticky ? 'sticky-footer' : ''}`}
      style={style}
    >
      {children || defaultContent}
    </footer>
  );
};

export default Footer;